import React, { useEffect } from "react";
import { any } from "prop-types";

import { PopupButton } from "@typeform/embed-react";

import CoverPorfolio from "../../components/cover-portfolio";
import PeopleOfMasamune from "../../components/people-of-masamune";
import { DetailsProject } from "../../components/portfolio-components";

import { FullWidthVideo } from "../../ui-components/videos";
import {
	LargeHeading,
	LargeText,
	LargeTitle,
	MediumHeading,
	MediumTitle,
	SmallTitle,
} from "../../ui-components/texts";
import {
	Column,
	Container,
	ContainerBlock,
} from "../../ui-components/columns/components";
import { ScrollXImages } from "../../ui-components/force-scroll-x";

// images
import imageCover from "../../media/images/portfolio-images/superstylin/image-cover.jpg";
import { useTranslate } from "../../contexts/translate";

const Superstylin = ({
	setNextPageHref = () => {},
	setNextPageName = () => {},
}) => {
	useEffect(() => {
		setNextPageHref("/projects/peasy");
		setNextPageName("Peasy");
		document.title = 'Superstylin - Cutting Edge Digital Creative Studio'
	}, []);

	const { translations } = useTranslate();

	const peoples = [
		{
			fullname: "Andrea Carollo",
			image: require("../../media/team-images/Andrea Carollo.jpg").default,
			role: translations === null ? "" : translations.about.peoples[4].role,
			//description:
				//translations === null ? "" : translations.about.peoples[4].description,
			description: "",
		},
		{
			fullname: "Magda Sgarella",
			image: require("../../media/team-images/Magda Sgarella.jpg").default,
			role: translations === null ? "" : translations.about.peoples[5].role,
			description:
				translations === null ? "" : translations.about.peoples[5].description,
		},
		{
			fullname: "Simone Scalia",
			image: require("../../media/team-images/Simone Scalia.jpg").default,
			role: translations === null ? "" : translations.about.peoples[7].role,
			description:
				translations === null ? "" : translations.about.peoples[7].description,
		},
	];

	const itemsList1 = [
		{
			src: require("../../media/images/portfolio-images/superstylin/gallery-1.jpg")
				.default,
		},
		{
			src: require("../../media/images/portfolio-images/superstylin/gallery-2.jpg")
				.default,
		},
		{
			src: require("../../media/images/portfolio-images/superstylin/gallery-3.jpg")
				.default,
		},
		{
			src: require("../../media/images/portfolio-images/superstylin/gallery-4.jpg")
				.default,
		},
	];

	return (
		<div className="project-page project-page-us-lecce overflow-hidden">
			<CoverPorfolio
				background="#fff"
				title="Superstylin'"
				text={translations && translations.superstylin.intro}
				image={imageCover}
			/>

			<DetailsProject
				client="Superstylin'"
				services={["CRO", "Digital Product", "Social Advertising"]}
				timeframe={"2019 - Today"}
				introduction={
					<>
						<LargeText>
							{translations && translations.superstylin.descriptions[0]}
						</LargeText>
						<LargeText>
							{translations && translations.superstylin.descriptions[1]}
						</LargeText>
					</>
				}
			/>

			<section
				className="theme-dark mid-padding"
				style={{ background: "#e7ddfc" }}
			>
				<Container>
					<div className="wrapper fluid">
						<Column className="w-80">
							<LargeHeading>{translations && translations.superstylin.sections[0].title}</LargeHeading>
							<LargeText>
								{translations && translations.superstylin.sections[0].text}
							</LargeText>
						</Column>
					</div>
				</Container>

				<ContainerBlock className="fluid" style={{ padding: "0 50px" }}>
					<ScrollXImages
						id="scroll-images-1"
						className="theme-light pt-100 no-padding light-section"
						style={{ background: "#e7ddfc" }}
						items={itemsList1}
					/>
				</ContainerBlock>
			</section>

			<section
				className="theme-light mid-padding"
				style={{ background: "#fff" }}
			>
				<Container>
					<div className="wrapper fluid">
						<Column className="w-100">
							<LargeTitle>{translations && translations.superstylin.sections[1].title}</LargeTitle>
							<MediumHeading>
								{translations && translations.superstylin.sections[1].text}
							</MediumHeading>
						</Column>
					</div>
				</Container>

				<Container className="pt-50">
					<div className="wrapper fluid">
						<Column className="w-40">
							<MediumTitle>+ 506,20%</MediumTitle>
							<MediumHeading>ROAS</MediumHeading>
						</Column>
						<Column className="w-40">
							<MediumTitle>2,51%</MediumTitle>
							<MediumHeading>Click-through rate</MediumHeading>
						</Column>
					</div>
				</Container>

				<Container>
					<div className="wrapper fluid">
						<Column className="w-40">
							<MediumTitle>+ 267%</MediumTitle>
							<MediumHeading>Orders</MediumHeading>
						</Column>
						<Column className="w-40"></Column>
					</div>
				</Container>
			</section>

			<PeopleOfMasamune peoples={peoples} />
				<div className="cta-single-project">
				<div className="cta-single-project-inner">
					<p>{translations && translations.ctasingleproject.text}</p>
					<button
						className="leadconnector-button"
						onClick={() => {
							const overlay = document.createElement("div");
							overlay.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													background-color: rgba(0, 0, 0, 0.7);
													backdrop-filter: blur(5px);
													z-index: 9998;
												`;

							const modal = document.createElement("div");
							modal.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													z-index: 9999;
												`;

							const closeBtn = document.createElement("button");
							closeBtn.innerHTML = "✕";
							closeBtn.style.cssText = `
													position: fixed;
													top: 30px;
													right: 30px;
													width: 50px;
													height: 50px;
													border: none;
													background-color: rgba(255, 255, 255, 0.2);
													color: white;
													border-radius: 50%;
													cursor: pointer;
													font-size: 28px;
													z-index: 10000;
													transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
													backdrop-filter: blur(10px);
													border: 1px solid rgba(255, 255, 255, 0.3);
													display: flex;
													align-items: center;
													justify-content: center;
												`;
							closeBtn.onmouseover = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
								closeBtn.style.transform = "scale(1.15) rotate(90deg)";
								closeBtn.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.3)";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.5)";
							};
							closeBtn.onmouseout = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
								closeBtn.style.transform = "scale(1) rotate(0deg)";
								closeBtn.style.boxShadow = "none";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.3)";
							};
							closeBtn.onclick = () => {
								overlay.style.opacity = "0";
								modal.style.opacity = "0";
								overlay.style.transition = "opacity 0.4s ease-out";
								modal.style.transition = "opacity 0.4s ease-out";
								setTimeout(() => {
									document.body.removeChild(overlay);
									document.body.removeChild(modal);
								}, 400);
							};

							const iframe = document.createElement("iframe");
							iframe.src =
								"https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true";
							iframe.style.cssText = `
													width: 100%;
													height: 100%;
													border: none;
												`;
							iframe.allowFullscreen = true;

							modal.appendChild(iframe);
							modal.appendChild(closeBtn);
							document.body.appendChild(overlay);
							document.body.appendChild(modal);

							overlay.onclick = () => {
								document.body.removeChild(overlay);
								document.body.removeChild(modal);
							};
						}}
					>
						{translations && translations.ctasingleproject.button}
					</button>
				</div>
			</div>
		</div>
	);
};

Superstylin.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default Superstylin;
